import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-部门",
  "use": "icon-部门-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-部门\"><path d=\"M955.712 277.312 955.712 0 68.288 0 68.288 277.312 0 277.312 0 1024 204.8 1024 204.8 277.312 136.512 277.312 136.512 68.288 477.888 68.288 477.888 277.312 409.6 277.312 409.6 1024 614.4 1024 614.4 277.312 546.112 277.312 546.112 68.288 887.488 68.288 887.488 277.312 819.2 277.312 819.2 1024 1024 1024 1024 277.312Z\" p-id=\"1492\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol